import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  satisfactionperceptions: []
}

// getters
export const getters = {
  satisfactionperceptions: state => state.satisfactionperceptions
}

// mutations
export const mutations = {
  [types.FETCH_SATISFACTIONPERCEPTIONS_SUCCESS] (state, { satisfactionperceptions }) {
    state.satisfactionperceptions = satisfactionperceptions
  },

  [types.FETCH_SATISFACTIONPERCEPTIONS_FAILURE] (state) {
    state.satisfactionperceptions = []
  }
}

// actions
export const actions = {
  async fetchSatisfactionperceptions ({ commit }) {
    try {
      const response = await axios.get(`/api/satisfactionperceptions`)

      commit(types.FETCH_SATISFACTIONPERCEPTIONS_SUCCESS, { satisfactionperceptions: response.data })
    } catch (error) {
      console.error(error)
      commit(types.FETCH_SATISFACTIONPERCEPTIONS_FAILURE)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/satisfactionperceptions.js